module.exports = __webpack_public_path__ + "img/CM-JN-24-Hyundai-Established.2abcc7ee.jpg";